import { PILLAR, WELL, COUPLING, FOB, CABLE, PON_BOX } from "../Optics/Constants/ConstantsOptics";
import { Snackbar } from '@mui/material';
import CustomSnackbar from "../Optics/Components/CustomSnackbar";
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import React, { useState} from "react";
import { RESTORED_ADMIN_COMPONENT_STATUS_API_URL, GET_ADMIN_COMPONENT_ID_API_URL } from "../Optics/OpticApiConfig";
import axios from 'axios';

const AdminRestoredStatusComponent  = ({ open, onClose }) => {

    const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();

    const [selectedComponent, setSelectedComponent] = useState('');
    const [inputId, setInputId] = useState('');
    const username = useState(localStorage.getItem('username'));
    const token = localStorage.getItem('token');
    const [data, setData] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    const onCloseModal = async () => {
        setSelectedComponent('');
        setInputId('');
        setData([]);
        setIsDataLoaded(false);
        onClose();
    }

    const getDataComponents = async () => {
        setData([]);
        setIsDataLoaded(false);

        if(selectedComponent === '' || inputId === ''){
            showSnackbar('Пустой ID или тип компонента!!!', 'snackbarWarning');
            return;
        }
        try {
            const response = await axios.get(
                `${GET_ADMIN_COMPONENT_ID_API_URL}`,
                {
                    params: { id: inputId, flag: selectedComponent },
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}` 
                    }
                }
            );
    
            setData(response.data);
            setIsDataLoaded(response.data.length > 0);
        } catch (error) {
            console.error('Ошибка при получении данных:', error);
        }
    };

    const restoredComponents = async () => {
       
       

        if(selectedComponent === '' || inputId === '') {
          showSnackbar('Пустой ID или тип компонента!!!', 'snackbarWarning');
          return;
        }  
        else if (!token) {
            showSnackbar('Ошибка! Токен не найден');
            return;
        } else if (!username) {
            showSnackbar('Ошибка! User не найден');
            return;
        }
        else {
    
          if (selectedComponent !="") {
            try {
                const response = await axios.patch(
                    `${RESTORED_ADMIN_COMPONENT_STATUS_API_URL}${inputId}?flag=${selectedComponent}`,
                    null,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        }
                    }
                );
        
                if (response.status === 200) {
                    const message = response.data.message;
                    showSnackbar(`${message}`, 'snackbarWarning');
                    setSelectedComponent('');
                    setInputId('');
                    setData([]);
                    setIsDataLoaded(false);
                } else {
                    const message = response.data.message || 'Неизвестная ошибка';
                    showSnackbar(message, 'snackbarWarning');
                }
            } catch (error) {
                showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
            }
          }
    
         
          
          else {
            showSnackbar('Выберите тип компонента/ID', 'snackbarWarning');
          }
        }
      }
    
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg" 
            PaperProps={{
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    padding: '20px',
                    overflowX: 'auto',
                },
            }}
            className="modalStyle"
        >
            <DialogContent>
            <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset' }}>Восстановление компонента где Status=0</label>
                <hr className='horizontalLineModal' style={{marginBottom:"0px"}} />

                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <select
                        className="selectStyleModal"
                        style={{width:"200px", marginTop: "17px"}}
                        value={selectedComponent}
                        onChange={(e) => setSelectedComponent(e.target.value)}
                    >
                        <option value="">Тип компонента</option>
                        <option value={PILLAR}>Опора</option>
                        <option value={WELL}>Колодец</option>
                        <option value={COUPLING}>Муфта</option>
                        <option value={FOB}>Фоб</option>
                        <option value={CABLE}>Кабель</option>
                        <option value={PON_BOX}>Пон-бокс</option>
                    </select>
                    <br />

                    <input
                        type="number"
                        placeholder="Введите ID"
                        className='inputDeleteModal'
                        style={{width:"200px", marginTop: "10px"}}
                        value={inputId}
                        onChange={(e) => setInputId(e.target.value)}
                    />
                    <br />

                    <button className='buttonIsChangeModal' style={{width: "auto"}} onClick={getDataComponents}>Поиск</button>
                    <hr className='horizontalLineModal' />
                    
                </div>
                <br/>
                <div className="table-container">
                <table className="custom-table">
               
            <thead>
                <tr>
                    <th>Тип</th> 
                    <th>ID</th>                  
                    <th>Имя</th>
                    <th>Комент</th>
                    <th>Округ</th>
                    <th>Создано</th>
                    <th>Статус</th>
                    <th>Создал</th>                 
                    <th>Ранг</th>
                </tr>
            </thead>
            <tbody>
                {data.map((item) => (
                    <tr key={item.id}>
                        <td>{item.type}</td>
                        <td>{item.id}</td>                      
                        <td>{item.couplingName || item.fobName}</td>
                        <td>{item.description}</td>
                        <td>{item.canton}</td>
                        <td>{new Date(item.createDate).toISOString().slice(0, 19).replace("T", " ")}</td>
                        <td>{item.status}</td>
                        <td>{item.authorId}</td>                      
                        <td>{item.rankComponentName}</td>
                    </tr>
                ))}
            </tbody>
        </table>
       
        </div>
      
        {isDataLoaded && (
            <button className="buttonIsRestoreModal" style={{ width: "auto", marginTop:"0px" }} onClick={restoredComponents}>
                Восстановить
            </button>
        )}
        <hr className='horizontalLineModal' />
                
            </DialogContent>
            <DialogActions>
                <Button onClick={onCloseModal} class="buttonIsHideModal">
                    Закрыть
                </Button>
            </DialogActions>

             {/* Snackbar */}
                <Snackbar
                    anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                    }}
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={handleCloseSnackbar}
                    message={snackbarMessage}
                    ContentProps={{
                        style: {
                        color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
                        }
                    }}
                    />
        </Dialog>
    );
};

export default AdminRestoredStatusComponent ;